// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__O8PYb","footer-justify":"Footer_footer-justify__rAEH-"};